var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgFakeCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 387,
    viewBox: "0 0 620 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13992_47748)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.321289,
    width: 620,
    height: 386.171,
    fill: "url(#paint0_linear_13992_47748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.905 185.702C588.604 252.2 614.259 323.651 620 351.064V-198.079C620 -157.402 552.438 -101.692 531.905 -77.8159C511.372 -53.9402 432.55 -5.30432 417.978 2.65427C403.406 10.6129 390.159 21.2243 396.782 46.8687C403.406 72.513 461.032 102.579 531.905 185.702Z",
    fill: "#6D6D6D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.905 419.531C588.604 486.029 614.259 557.48 620 584.893V35.75C620 76.4272 552.438 132.137 531.905 156.013C511.372 179.889 432.55 228.525 417.978 236.483C403.406 244.442 390.159 255.053 396.782 280.698C403.406 306.342 461.032 336.408 531.905 419.531Z",
    fill: "#6D6D6D",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13992_47748",
    x1: 0,
    y1: 0.321289,
    x2: 620,
    y2: 386.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E659D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001029"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13992_47748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 386.171,
    fill: "white",
    transform: "translate(0 0.321289)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFakeCard);
export default __webpack_public_path__ + "static/media/BGFakeCard.ae4c5b8558b5dbbf89b452e31e5d9557.svg";
export { ForwardRef as ReactComponent };